export enum UserPermission {
  Owner = 'owner',
  Admin = 'admin',
  Moderator = 'moderator',
}
